import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import styles from './GreenBox.css';

const { div, h2, p } = hh(h);

const isImageUrl = str => ['.png', '.svg'].some(ext => str.slice(-4) === ext);
    
const GreenBox = ({ alpha, beta }) => (
    div({ className: styles.greenBox },[
        isImageUrl(alpha) ? h('img', { className: styles.greenBoxImage, src: alpha, alt: '' }) : h2({ className: styles.greenBoxTitle }, alpha),
        p(beta)
    ])
);

export default GreenBox;


/** WEBPACK FOOTER **
 ** ./src/Universities/GreenBox.js
 **/